
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { connect } from 'react-redux';
import {
	Redirect,
	Switch
} from 'react-router-dom';
import { withRouter } from "react-router";
import { headTitleTag } from '../../helpers/functions';

import { CurrentStepSetAction, setListDealersFiltred } from '../../actions/action';

import fetchApiData from '../apiHandlers/fetchApiData'
import BodyClassName from 'react-body-classname';
import DealerBlock from '../DealerBlock/DealerBlock';
import HappyHoureTitle from '../Titles/HappyHoureTitle';
import ShowMoreButton from '../buttons/showMoreButton';
import CONSTANTS from '../../constants';
import { isEqual } from 'lodash'
import './pagenomap.css';


var labels = window.labels;

const mapStateToProps = state => state;
const mapDispatchToProps = { CurrentStepSetAction, setListDealersFiltred };
const google = window.google;

class PageNoMap extends Component {
	_isMounted = false;
	constructor(props) {
		super(props);
		this.getDistanceBetweenPlaces = this.getDistanceBetweenPlaces.bind(this);
		this.setOpendDealerBlock = this.setOpendDealerBlock.bind(this);
		this.setLatLangAccordingToCityInURL = this.setLatLangAccordingToCityInURL.bind(this);
		this.showMore = this.showMore.bind(this);
		this.state = {
			data: [],
			dealersFiltred: this.props.store.dealersFiltred,
			selectedDate: [],
			openDealerBlock: null,
			isLoading: false,
			errorRedirect: null,
			pagination: 10,
			map: {
				adress: "",
				lat: 0,
				lng: 0,
			}
		};

	}
	setLatLangAccordingToCityInURL(props = this.props) {
		let geocoder = new google.maps.Geocoder;
		return new Promise((resolve, reject) => {
			geocoder.geocode({ 'address': props.match.params.adress }, function (results, status) {
				if (status === 'OK') {
					console.log(results);
					if (results[0]) {
						console.log(results[0].formatted_address);
						this.setState({
							map: {
								adress: results[0].formatted_address,
								lat: results[0].geometry.location.lat(),
								lng: results[0].geometry.location.lng(),
							}
						});
						resolve(results[0].formatted_address);
					} else {
						console.log('No results found');
					}
				} else {

					this.setState({ errorRedirect: true });
					console.error('Geocoder failed due to: ' + status);
				}
			}.bind(this));
		});

	}
	componentDidMount() {
		this.props.CurrentStepSetAction(2);
		this._isMounted = true;
		this.setState({ isLoading: true });

		this.setLatLangAccordingToCityInURL().then(() => {
			const listDealers = new fetchApiData();
			listDealers.getListDealers()
				.then(data => {
					if (this._isMounted) {

						this.setState({
							isLoading: false,
							data: data.d,
						});
						this.props.store.filterDealersBy.length > 0 ? this.filterDealers() : this.setState({ dealersFiltred: data.d })

						this.setState({
							selectedData: Object.values(this.getDistanceBetweenPlaces(this.props)).sort(function (a, b) {
								return a.Distance - b.Distance;
							}).slice(0, 10)
						});
						console.log(this.state.selectedData);

					}
				})
				.catch(error => {
					this.setState({
						error,
						isLoading: false
					})
					console.error('fail', error);
				});

		});

		// GA Start
		window.dataLayer.push({
			'event': 'updatevirtualpath',
			'brand': window.siteConfig['brand'],
			'virtualPageURL': "/dealer-locator/appointment-schedule-search",
			'pageName': window.siteConfig['pageName'],
			'language': window.siteConfig['language'],
			'country': window.siteConfig['currentCountry'],
			'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
			'siteTypeLevel2': "appointement",
			'siteOwner': "central",
			'siteTarget': "B2C",
			'siteFamily': "after-sales",
			'pageCategory': "dealer locator page",
		});

		// GA Ends

	}
	//flter the dealers and add the filtres liste to the store
	filterDealers = () => {
		let dealersFiltred = this.props.store.filterDealersBy.length > 0
			? this.state.data.filter(dealer =>
				this.props.store.filterDealersBy.every(elemnt => dealer.ListeIdSP.includes(elemnt)))
			: this.state.data
		this.setState({ dealersFiltred: dealersFiltred })
		this.props.setListDealersFiltred(dealersFiltred)
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	//call the filter methode if the filter by changed 
	componentDidUpdate = (prevProps) => {
		if (!isEqual(this.props.store.filterDealersBy, prevProps.store.filterDealersBy)) {
			this.filterDealers();
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setLatLangAccordingToCityInURL(nextProps).then(() => {

			this.setState({
				selectedData: Object.values(this.getDistanceBetweenPlaces(nextProps)).slice(0, 10)

			});

		});


	}
	getDistanceBetweenPlaces(urlProps = this.props) {
		let place = [this.props.store.selectedLat, this.props.store.selectedLong];
		let dealers = Object.assign({}, this.state.dealersFiltred);
		dealers = Object.values(dealers).map(function (dealer) {
			const currentAdress = new google.maps.LatLng(place[0], place[1]);
			const dealerLocation = new google.maps.LatLng(dealer.Latitude, dealer.Longitude);
			dealer.Distance = (google.maps.geometry.spherical.computeDistanceBetween(currentAdress, dealerLocation) / 1000).toFixed(2);
			return dealer;
		});
		this.setState({
			dealersFiltred: dealers.sort(function (a, b) {
				return a.Distance - b.Distance;
			})
		});
		return dealers.sort(function (a, b) {
			return a.Distance - b.Distance;
		});
	}
	showMore() {
		this.setState({
			selectedData: this.state.dealersFiltred.slice(0, this.state.pagination + 10),
			pagination: this.state.pagination + 10,
		})
	}

	handleScrollToElement(idDealer) {
		console.log(idDealer);
		const d = ReactDOM.findDOMNode(this.refs['id' + idDealer]);
		if (d) {
			d.focus();
			window.scrollTo(0, d.offsetTop);
		}


	}
	setOpendDealerBlock(idDealer) {
		this.setState({ openDealerBlock: idDealer });
		this.handleScrollToElement(idDealer);
	}

	render() {

		const SEO_TITLE = (window.siteConfig.v2multicreneaux != undefined ? window.siteConfig.v2multicreneaux.Title : '');
		const SEO_DESC = (window.siteConfig.v2multicreneaux != undefined ? window.siteConfig.v2multicreneaux.MetaDescription : '');
		const happyHoureMessage = (window.innerWidth <= 800 ? CONSTANTS.LABELS.multislots_happy_hours_mobile : CONSTANTS.LABELS.multislots_happy_hours_desktop);
		const isHappuHoureMessageEnabled = (happyHoureMessage.length > 2 ? true : false);

		return (
			<div className="content-wrapper container-small-content">
				{
					headTitleTag(SEO_TITLE.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()).replace('[nom_ville]', this.state.map.adress.toUpperCase()),
						SEO_DESC.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()).replace('[nom_ville]', this.state.map.adress.toUpperCase()))
				}
				{this.state.errorRedirect &&
					<Switch>
						<Redirect to={`/404`} />
					</Switch>}
				<BodyClassName className="page--dealers" />
				<p tabIndex="0" className="content-headline">{CONSTANTS.LABELS.multislots_select_slot}</p>
				{isHappuHoureMessageEnabled && <HappyHoureTitle />}

				{this.state.selectedData && this.state.selectedData.map(function (item, key) {
					return <DealerBlock
						dealerID={item.DealerId}
						dealerGeoId={item.GeoId}
						dealerName={item.Name}
						dealerDistance={false}
						dealerCity={item.City}
						dealerZipCode={item.ZipCode}
						position={{ lat: Number(item.Latitude), lng: Number(item.Longitude) }}
						dealerAdress={item.Address}
						dealerPremServices={item.ListeIdSP}
						listPremiumServices = {this.props.store.listPremiumServices}
						dealerLCV={item.LCV}
						dealerPC={item.PC}
						SelfReception={item.SelfReception}
						opendDealerBlockID={this.setOpendDealerBlock}
						dealerOpen={(this.state.openDealerBlock == item.DealerId ? "f" : "false")}

						key={key} />
				}.bind(this)
				)}
				<ShowMoreButton onClick={this.showMore} />

			</div>
		);
	}
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageNoMap));
